import { render, staticRenderFns } from "./column-block.vue?vue&type=template&id=3a19162f&"
import script from "./column-block.vue?vue&type=script&lang=js&"
export * from "./column-block.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports